// import MaterialTable from 'material-table'
import React, { useEffect, useState } from 'react'
import Service from '../Networking/NetworkingUtils';
import { getCookie } from '../Utils/CookieHelper';
import { useSnackbar } from 'notistack';
import ModelVersion from './ModelVersion';
import AddBoxIcon from '@mui/icons-material/AddBox';
import { Box, Button, CircularProgress, Collapse, Dialog, DialogActions, DialogContent, DialogTitle, IconButton, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Tooltip, Typography } from '@mui/material';
import moment from 'moment';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@mui/icons-material/KeyboardArrowUp';
import EditIcon from '@mui/icons-material/Edit';


var token = getCookie("bb_metaverse_token");
const user = JSON.parse(getCookie("bb_metaverse_user"));

const ModelLibrary = (props) => {

    const [data, setData] = useState([])
    const [isLoading, setIsLoading] = useState(true)
    const { enqueueSnackbar } = useSnackbar();
    const [columns] = useState([
        { title: 'Name', field: 'name' },
        { title: 'Description', field: 'description' },
        {
            title: 'Date Created', field: 'date_created', type: 'date',
            render: rowData => { return moment(rowData.date_created).format('DD/MM/YYYY') }
        }
    ])
    const [dialogopen, setDialogopen] = useState(false)
    const [addData, setAddData] = useState({})
    const [rowData, setRowData] = useState({})
    const [isEdit, setIsEdit] = useState(false)
    const [editObj, setEditObj] = useState({})

    const getData = () => {
        setIsLoading(true)
        Service.get(`/api/modular/object/get_modular_objects_by_category/?modular_category=${props.rowData.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
        }).then(res => {
            let data = res.data
            data.forEach(d => d.open = false)
            console.log(data)
            setData([...data])
            setIsLoading(false)
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
    }

    useEffect(() => {
        getData()
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const postData = (data) => {
        if(!data.name){
            enqueueSnackbar('Name is required!', {
                variant: 'warning'
            });
        }else{
        setIsLoading(true)
        data.created_by = user.id
        data.modular_category = props.rowData.id
        Service.post(`/api/modular/object/create_modular_object/?modular_category=${props.rowData.id}`, {
            headers: {
                Authorization: "Token " + token,
            },
            data: data,
        }).then(res => {
            getData()
            enqueueSnackbar('Model added Successfully!', {
                variant: 'success'
            })
            setDialogopen(false);
        }).catch(error => {
            console.log(error)
            enqueueSnackbar('Something went wrong!', {
                variant: 'error'
            })
            setIsLoading(false)
        }
        )
        }
    }

    const editData = (data) => {
        if (!data.name) {
            enqueueSnackbar('Name is required!', {
                variant: 'warning'
            });
            return;
        } else {
            setIsLoading(true)
            data.created_by = user.id
            Service.patch('/api/modular/object/update_modular_object/', {
                headers: {
                    Authorization: "Token " + token,
                },
                data: data
            })
                .then(res => {
                    setDialogopen(false)
                    enqueueSnackbar('Model edited Successfully', {
                        variant: 'success'
                    });
                    getData()
                })
                .catch(error => {
                    console.log(error)
                    enqueueSnackbar('Something went wrong!', {
                        variant: 'error'
                    });
                });
        }
    }

    const submit = (e) => {
        e.preventDefault();
        postData(addData);
    }

    return (
        <div>
            {/* <MaterialTable
                title="Model Library"
                columns={}
                isLoading={isLoading}
                data={data}
                detailPanel={rowData =>
                    <Box margin={2}>
                        <ModelVersion model={rowData} />
                    </Box>
                }
                onRowClick={(event, rowData, togglePanel) => togglePanel()}
                editable={{
                    onRowAdd: newData =>
                        new Promise((resolve, reject) => {
                            postData(newData)
                            resolve();
                        }),
                    onRowUpdate: (newData, oldData) =>
                        new Promise((resolve, reject) => {
                                editData(newData)
                                resolve();
                        }),
                    // onRowDelete: oldData =>
                    //   new Promise((resolve, reject) => {
                    //     setTimeout(() => {
                    //       deleteData(oldData)
                    //       const dataDelete = [...data];
                    //       const index = oldData.tableData.id;
                    //       dataDelete.splice(index, 1);
                    //       setData([...dataDelete]);
                    //       resolve()
                    //     }, 1000)
                    //   }),
                }}

                options={{
                    padding: "dense",
                    paging: false,
                    filtering: true,
                    actionsColumnIndex: -1
                }}
            /> */}
            {isLoading ? <Box display={'flex'} justifyContent={'center'} alignItems={'center'} width='100%'><CircularProgress /></Box> :
                <TableContainer component={Paper}>
                    <Box display='flex' justifyContent='space-between' alignItems='center' width='100%' paddingX={2}>
                        <Typography variant="h5">Model Library</Typography>
                        <Box>
                            <Button onClick={() => { setDialogopen(true); setIsEdit(false); }}><Tooltip title="Add"><AddBoxIcon /></Tooltip></Button>
                        </Box>
                    </Box>
                    <React.Fragment>
                        <Table>
                            <TableHead>
                                <TableRow sx={{ '& > *': { borderBottom: 'unset' } }}>
                                    <TableCell />
                                    {columns && columns.map((column) => (
                                        <TableCell key={column.field}>{column.title}</TableCell>
                                    ))}
                                    <TableCell>Actions</TableCell>
                                </TableRow>
                            </TableHead>
                            <TableBody>
                                {data && data.map((row) => (
                                    <React.Fragment key={row.id}>
                                        <TableRow>
                                            <TableCell>
                                                <IconButton
                                                    aria-label="expand row"
                                                    size="small"
                                                    onClick={() => {
                                                        row.open = !row.open
                                                        setData([...data])
                                                        setRowData(row)
                                                    }}
                                                >
                                                    {row.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                                                </IconButton>
                                            </TableCell>
                                            {columns && columns.map((column) => (
                                                <TableCell key={column.field}  >
                                                    {column.render ? column.render(row) : column.lookup ? column.lookup[row[column.field]] : row[column.field]}
                                                </TableCell>
                                            ))}
                                            <TableCell>
                                                <Tooltip title="Edit"><span><IconButton onClick={() => { setIsEdit(true); setEditObj(row); setDialogopen(true) }}><EditIcon /></IconButton></span></Tooltip>
                                            </TableCell>
                                        </TableRow>
                                        <TableRow>
                                            <TableCell sx={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
                                                <Collapse in={row.open} timeout="auto" unmountOnExit>
                                                    <Box margin={2}>
                                                        <ModelVersion model={rowData} />
                                                    </Box>
                                                </Collapse>
                                            </TableCell>
                                        </TableRow>
                                    </React.Fragment>

                                ))}
                            </TableBody>
                        </Table>

                    </React.Fragment>
                </TableContainer>}
            <Dialog maxWidth="xs" fullWidth={true} open={dialogopen} onClose={() => setDialogopen(false)}>
                <DialogTitle marginTop="2px" spacing={2}>{isEdit ? "Edit Model Library" : "Add Model Library"}</DialogTitle>
                <DialogContent>
                    <Box sx={{ gap: "12px", display: "flex", justifyContent: "center", alignItems: 'center', flexDirection: "column" }}>
                        <TextField variant='outlined' id="name" fullWidth label='Name' value={isEdit ? editObj.name : addData.name} onChange={(e) => { isEdit ? setEditObj({ ...editObj, name: e.target.value }) : setAddData({ ...addData, name: e.target.value }) }} sx={{ marginTop: '10px' }}></TextField>
                        <TextField variant='outlined' id="description" fullWidth label='Description' value={isEdit ? editObj.description : addData.description} style={{ marginTop: '5px' }} onChange={(e) => { isEdit ? setEditObj({ ...editObj, description: e.target.value }) : setAddData({ ...addData, description: e.target.value }) }}></TextField>
                    </Box>
                </DialogContent>
                <DialogActions>
                    <Button color="primary" variant="text" onClick={() => setDialogopen(false)}>Cancel</Button>
                    <Button color="primary" variant="text" onClick={(e) => { isEdit ?  editData(editObj) : submit(e) }}>{ isEdit ? 'Edit' : 'Add'}</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}

// export default withSnackbar(ModelLibrary)
export default ModelLibrary;